import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import clsx from "clsx";
import HeaderProgress from "./HeaderProgress";
// import Stats from './Stats2';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1em 0",
    background: "#fff",
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
  },
  img: {
    width: "30%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& img": {
      display: "block",
    },
  },
  right: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    boxSizing: "border-box",
    padding: "0 20px",
    width: "70%",
    alignItems: "flex-start",
    "& h2": {
      marginTop: 0,
      color: theme.palette.primary.dark,
    },
    "& a": {
      whiteSpace: "nowrap",
      maxWidth: "100%",
      "& span": {
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
  },
  button: {
    maxWidth: 320,
    "& > span:first-child": {
      display: "inline-block",
    },
  },
  "@media(max-width: 850px)": {
    container: {
      flexWrap: "wrap",
    },
    img: {
      width: "100%",
      marginBottom: 20,
    },
    right: {
      width: "100%",
      marginBottom: 20,
      textAlign: "center",
      display: "block",
    },
  },
}));

function CourseHeader(props) {
  const classes = useStyles();
  const courseId = props.currentCourseId;
  let currentExercise = false;
  if (courseId) {
    const currentExerciseObj = props.currentExercise[courseId]
      ? props.currentExercise[courseId]
      : props.courses.find((course) => course.id === courseId);
    if (currentExerciseObj) currentExercise = currentExerciseObj.start;
  }

  return (
    <div className={classes.root}>
      <div className={clsx("container", classes.container)}>
        <div className={classes.img}>
          <img src={props.imgSrc} alt="" />
        </div>
        <div className={classes.right}>
          <h2>{props.title}</h2>
          {currentExercise && (
            <Button
              className={classes.button}
              variant="contained"
              size="large"
              color="primary"
              component={Link}
              to={currentExercise.link}
            >
              {currentExercise.title}
            </Button>
          )}
          <HeaderProgress
            progress={props.progress}
            sectionsTotal={props.sectionsTotal}
            sectionsComplete={props.sectionsComplete}
          />
        </div>
        {/* <Stats /> */}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    currentExercise: state.userState.currentExercise,
    currentCourseId: state.userState.currentCourseId,
    courses: state.courses,
  };
};

export default connect(mapStateToProps)(CourseHeader);
